export default __webpack_public_path__ + "c888b27a3b59f0d75dfe922ebee3d8ff.png";